import React from 'react'
import {Form, DatePicker, Select, Col} from "antd";
import {Field} from "./index";
import moment from "moment";
import Utils from "../../utils";
import {FieldBase} from "./components/FieldBase";

export class FieldDate extends Field {

  constructor(obj={}) {
    super(obj);
  }

  disabledDate = (current) => {
    // Can not select days before today and today
    let dataMin = undefined;
    let dataMax = undefined;
    if(this.min)
      if(this.min == "today")
        dataMin = moment()
      else
        dataMin = moment(this.min, "DD/MM/YYYY")
    if(this.max)
      if(this.max == "today")
        dataMin = moment()
      else
        dataMax = moment(this.max, "DD/MM/YYYY")
    return current && current <= dataMax || current > dataMin;
  }

  getComponent (form) {
    const dateFormat = ['DD/MM/YYYY'];

    return () => (
      <FieldBase condition={this.condition} form={form} size={this.size} label={this.label} name={this.name} value={this.value} help={this.help}>

        <DatePicker
          disabled={this.disabled}
          format={dateFormat}
          style={{ width: '100%' }}
          disabledDate={this.disabledDate}
        />
      </FieldBase>);
  }

  transformToField = (data) => {
    this.name = data.name;
    this.label = data.label;
    this.type = data.type;
    this.size = data.size ?? this.size;
    this.value = this.transformValueToDate(data.value);
    this.condition = data.condition ?? true;
    this.disabled = data.disabled ?? false;
    this.help = data.help;
    this.min = data.min ?? undefined;
    this.max = data.max ?? undefined;

    return this;
  }

  transformValueToDate = (str) => {
    const result = moment(str, 'YYYY-MM-DD')
    return result.isValid() ? result  : undefined;
  }

  transformValueToField = (data) => {
    let result = moment(data, "DD/MM/YYYY")
    if(!result.isValid())
      result = moment(data, "YYYY-MM-DD")

    return result;
  };

}


